export default __webpack_public_path__ + "static/production4r-089926dcf99daa3e1414c7141cfb1e19.jpg";